<script setup lang="ts">
/** Text input primitive. Extra attributes (type, autocomplete, id, aria-*) pass through. */
const model = defineModel<string>({ default: '' });
</script>

<template>
  <input v-model="model" class="input" />
</template>
